<template>
    <div id="setting-screen" class="mt-0">
        <v-tabs :value="tab" @change="changeTab" background-color="transparent" class="bg-white mb-4 rounded">
            <v-tab v-for="tabItem in tabItems" :tabindex="tabItem.index" :key="tabItem.index"
                @click="loadRoute(tabItem.routeName)">{{ tabItem.title }}</v-tab>
        </v-tabs>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            tab: 0,
        };
    },
    computed: {
        tabItems() {
            return [
                {
                    title: this.$t('BOOKING_LIST_GROUP'),
                    key: 'listBookingGroup',
                    routeName: "listBookingGroup",
                },
                {
                    title: this.$t('LIST_PROFILE_GROUP'),
                    key: 'profilesGroup',
                    routeName: "profilesGroup",
                }
            ]
        }
    },
    created() {
        switch (this.$route.name) {
            case 'listBookingGroup':
                this.tab = 0;
                break;
            case 'profilesGroup':
                this.tab = 1;
                break;
            case 'bookingDetailGroup':
                this.tab = 0;
                break;
            case 'detailProfilesGroup':
                this.tab = 1;
                break;

            default:
                break;
        }
        // this.fetchData();
    },
    watch: {
        '$route.query': 'fetchData',
    },
    methods: {
        changeTab(tabIndex) {
            this.tab = tabIndex;
        },
        loadRoute(routeName) {
            this.$router.push({ name: routeName });
        },
    }
};
</script>
